export default "__VITE_ASSET__BXcOylTR__"